export default function TabLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col" data-testid="tab-content">
      {children}
    </div>
  );
}
